import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

type LogoProps = {
    height?: number;
};

export function Logo({ height }: LogoProps) {
    const { t } = useTranslation();
    const theme = useTheme();
    const isDark = theme.palette.mode === "dark";

    const logoHeight = height ?? 60;
    const logoWidth = (109 / 56) * logoHeight;
    const logoSrc = isDark
        ? "/images/radar-logo-white.svg"
        : "/images/radar-logo-full-colour.svg";

    return (
        <img
            src={logoSrc}
            alt={t("logo-alt-text")}
            width={logoWidth}
            style={{ display: "block", height: "auto" }}
        />
    );
}
